import * as React from 'react';

import {InfoCircleRegularIcon} from '../icon/svg/info-circle-regular-icon';
import {InfoIcon} from '../icon/svg/info-icon';

import styles from './help-styles.module.css';

type Props = {
    onClick: (e: React.MouseEvent) => void;
    variant?: 'error' | 'green' | 'blue' | 'greyLt';
    size?: number;
    noPadding?: boolean;
    useInfoRegularIcon?: boolean;
};

// @ts-expect-error
export const HelpButton = React.forwardRef<Props, HTMLButtonElement>((props: Props, ref) => {
    const getStyleName = () => {
        if (props.variant === 'error') {
            return styles['help-icon--error'];
        }

        if (props.variant === 'green') {
            return styles['help-icon--green'];
        }

        if (props.variant === 'blue') {
            return styles['help-icon--blue'];
        }

        if (props.variant === 'greyLt') {
            return styles['help-icon--grey-lt'];
        }

        if (props.noPadding) {
            return styles['help-icon--no-padding'];
        }

        return styles['help-icon'];
    };

    return (
        // @ts-expect-error
        <button type='button' onClick={props.onClick} ref={ref} className={getStyleName()}>
            {props.useInfoRegularIcon ? (
                <InfoCircleRegularIcon wrapWithDiv={false} size={props.size ? props.size : 16} />
            ) : (
                <InfoIcon
                    wrapWithDiv={false}
                    size={props.size ? props.size : 16}
                    // @ts-expect-error
                    useCurrentColor={true}
                />
            )}
        </button>
    );
});
